import script from "./PopularDestinationsContainerComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopularDestinationsContainerComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PopularDestinationsContainerComponent.vue?vue&type=style&index=0&id=3045c6fe&lang=css"

const __exports__ = script;

export default __exports__